import { useMutation } from '@tanstack/react-query';
import { authResendEmailVerificationCreate } from '@wellstone-solutions/api/v2';
import { AxiosError, AxiosResponse } from 'axios';

import type {
  ResendEmailVerification,
  ResendEmailVerificationInputRequest,
} from '@wellstone-solutions/api/v2';

const useResendEmailVerification = () => {
  return useMutation<
    AxiosResponse<ResendEmailVerification>,
    AxiosError<{ [key: string]: string[] }>,
    ResendEmailVerificationInputRequest
  >({
    mutationFn: ({ email }) => authResendEmailVerificationCreate({ email }),
  });
};

export { useResendEmailVerification };
